import { render, staticRenderFns } from "./FreezingIndexesChart.vue?vue&type=template&id=3b06bb87&"
import script from "./FreezingIndexesChart.vue?vue&type=script&lang=js&"
export * from "./FreezingIndexesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports